<template>
    <div class="bingZFB">
        <div class="form">
            <p class="tips">请确保输入支付宝账号和支付宝账户名一致</p>
            <p class="tips">否则将影响资金到账</p>
            <div class="inputView van-hairline--top-bottom">
                <input type="text" class="input" v-model="account" placeholder="请输入支付宝账户"/>
                <div class="van-hairline--top" />
                <input type="text" class="input" v-model="accountName" placeholder="请输入姓名"/>
            </div>
            <Button class="saveBtn" @click="save">保存</Button>
        </div>
    </div>
</template>

<script>
    /*
    * 绑定支付宝
    * */
    import {Button} from 'vant'
    import {bindZFB} from "../../../../api/bindZFB";

    export default {
        name: "BindZFB",
        components: {
            Button
        },
        data() {
            return {
                accountName: '',
                account: '',
                id: '',
                isClick: true
            }
        },
        created() {
            let {accountName, account, id} = this.$route.query;
            this.accountName = accountName;
            this.account = account;
            this.id = id;
        },
        methods: {
            save() {
                if (!this.isClick) return;
                this.isClick = false;
                if (!this.account) return this.toast({
                    text: '账户不能为空',
                    icon: 'warning',
                });
                if (!this.accountName) return this.toast({
                    text: '姓名不能为空',
                    icon: 'warning',
                });
                var param={
                    accountName: this.accountName,
                    account: this.account,
                    type:"ZFB",
                    appType: 'MINI_PROGRAM'
                };
                if (this.id){
                    param.id= this.id;
                }
                bindZFB(param).then(res => {
                    this.toast({
                        text: '更新账户成功',
                        icon: 'success'
                    });
                    this.$router.go(-1);
                }).catch(err => {
                    this.isClick = true;
                })
            }
        }
    }
</script>

<style lang='less' scoped>
    .bingZFB {
        min-height: 100vh;
        padding: 2.8vw 3.1vw 0;
        background-color: #f8f8f8;
        box-sizing: border-box;
        .form {
            padding: 3.2vw 4vw 5.6vw;
            background-color: #ffffff;
            box-shadow: 0vw 0.5vw 1.3vw -0.5vw rgba(0, 0, 0, 0.08);
            border-radius: 2.7vw;
            .tips {
                font-size: 3.2vw;
                color: #333333;
            }
            .inputView {
                margin-top: 2.5vw;
                .input {
                    display: block;
                    width: 100%;
                    height: 8vw;
                    border: none;
                    font-size: 3.2vw;
                    &::placeholder {
                        font-size: 3.2vw;
                    }
                }
            }
            .saveBtn {
                display: block;
                width: 78.8vw;
                height: 11.3vw;
                margin: 4vw auto 0;
                line-height: 11.3vw;
                background-color: #43a2fe;
                border-radius: 5.7vw;
                font-size: 4vw;
                color: #ffffff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/withdraw/bindZFB/BindZFB.vue